<template>
	<div>
		<div class="mobile-menu__overlay" />
		<div class="mobile-menu__container">
			<div class="mobile-menu__header">
				<h2>Table of Contents</h2>
				<div
					@click="closeMobileMenu()"
				>
					<font-awesome-icon 
						icon="stop-circle" 
					/>
				</div>
			</div>

			<div class="mobile-menu__content">
				<MenuItems 
					mobile-menu
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import MenuItems from '@/ui/views/MenuItems';

	export default {
		components: {
			MenuItems
		},
		data() {
			return {
				menuTimer: 500
			}
		},
		watch: {
			$route() {
				this.closeMobileMenu();
			}
		},
		methods: {
			closeMobileMenu() {
				const body = document.querySelector('body')
				
				body.setAttribute('data-menu-content', '');
				setTimeout(() => {
					body.setAttribute('data-menu-visible', '');
				}, this.menuTimer);

				setTimeout(() => {
					body.setAttribute('data-menu', '');
				}, this.menuTimer * 2);
			}
		}	
	};
</script>

<style lang="scss" scoped>
	.mobile-menu {
		&__overlay {
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background: rgba(0, 0, 0, 0.7);
			z-index: 9;
			display: none;
			opacity: 0;
			transition: all 0.5s ease;
		}

		&__container {
			position: fixed;
			top: 0;
			right: 0;
			height: 100vh;
			background: #ffffff;
			z-index: 10;
			box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.9);
			display: none;
			width: 0;
			transition: all 0.5s ease;
			padding-bottom: 2em;
		}

		&__header {
			display: flex;
			flex: 1;
			padding: 0.85em 0.75em;
			justify-content: center;
			align-items: center;
			border-bottom: 1px solid #eaeaea;
			color: $primary;
			opacity: 0;
			transform: translateX(10px);
			transition: all 0.5s ease;

			h2 {
				flex: 1;
				margin: 0;
				font-size: 1.2em;
			}
		}

		&__content {
			opacity: 0;
			transform: translateX(10px);
			transition: all 0.5s ease;
		}
	}

	body[data-menu="active"] {
		.mobile-menu {
			&__overlay, 
			&__container {
				display: block;
			}
		}
	}

	body[data-menu-visible="active"] {
		.mobile-menu {
			&__overlay {
				opacity: 1;
			}

			&__container {
				width: 320px;
			}
		}
	}

	body[data-menu-content="active"] {
		.mobile-menu {
			&__header,
			&__content {
				opacity: 1;
				transform: translateX(0);
			}

			&__container {
				overflow-y: auto;
			}
		}
	}
</style>